module.exports = __webpack_public_path__ + "static/media/new-car-transparent.a23fd997.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/new-car-transparent.png
// module id = 2733
// module chunks = 0